import Template from "./template";

export default {
  element: <Template />,
  loader: async ({ params }) => {
    return {};
  },
};

